<template>
  <div class="dh-psy-read-more">
    <Esi :src="universeSrc" />
    <Esi :src="generalSrc" :beforeHTML="generalBeforeHTML" :afterHTML="generalAfterHTML" />
  </div>
</template>

<script>
import Esi from '../Utilities/Esi.vue'
import { SERUM_BASE_URL } from '../../helpers/serum-helpers'

const getUniverseSrc = (selfId, universeId) => {
  const modifiers =
    'size=18&perspective=RICH&alignment=AUTO&display=true&arrangement.offset=0&arrangement.startoffset=0&arrangement.quantity=3&arrangement.repetition=LAST&arrangement.view%5B0%5D.perspective=LEAN&arrangement.view%5B0%5D.size=6&arrangement.view%5B0%5D.alignment=LEFT&paged=SIMPLE'
  return `${SERUM_BASE_URL}?id=${universeId}&secondary=${selfId}&${modifiers}`
}

const getGeneralSrc = selfId => {
  const generalFlowId = '1.11709637'
  const modifiers =
    'size=18&perspective=RICH&alignment=CENTER&scope=ARTICLE&created=1446130343000&head=Mer+langlesing+fra+NRK&arrangement.offset=0&arrangement.startoffset=0&arrangement.quantity=3&arrangement.repetition=PATTERN&arrangement.view%5B0%5D.perspective=BRIEF&arrangement.view%5B0%5D.size=6&arrangement.view%5B0%5D.alignment=RIGHT&paged=SIMPLE'
  return `${SERUM_BASE_URL}?id=${generalFlowId}&secondary=${selfId}&${modifiers}`
}

export default {
  data() {
    return {
      generalBeforeHTML:
        '<div class="g100 col fc s18 sg6 sg9 sg12 group-reference"><div class="group widget rich article-feature-group cf container-widget">',
      generalAfterHTML: `</div></div>`,
      universeId: this.$root.$data.universeId,
      selfId: this.$root.$data.selfId,
      universeSrc: getUniverseSrc(this.$root.$data.selfId, this.$root.$data.universeId),
      generalSrc: getGeneralSrc(this.selfId)
    }
  },
  mounted() {
    if (window.require) {
      window.require(['inline!standard:type/flow/Serum.Flow', 'inline!standard:jquery'], function(
        PaginatedFlow,
        $
      ) {
        PaginatedFlow.bootstrap($('.flow.js-initialize').removeClass('js-initialize'))
      })
    }
  },
  components: {
    Esi
  }
}
</script>

<style scoped lang="postcss">
  .dh-psy-read-more {
    max-width: 1180px;
    margin: 0 auto;

    & :global(.col) {
      float: none;
    }

    & :global(.skin-border),
    & :global(.skin-border-hover:hover) {
      border-color: #ddd;
    }

    & :global(.skin-plug-icon) {
      filter: saturate(0);
    }
  }
</style>
